import styled from "styled-components";

//MISC
import { COLORS, SIZE, BORDER_RADIUS, DEVICE_TYPE } from "constants/variables";

//ASETS
import cursorIcon from "assets/img/Cursor.png";

export const CardWrapper = styled.div`
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  width: 100%;
  padding: ${SIZE.max24} ${SIZE.max40};
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-height: 113px;
  height: 100%;
  min-height: 100px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-height: 180px;
    flex-direction: column;
    gap: 16px;
  }
`;

export const MobileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 0;
`;

export const SvgWrapper = styled.div`
  margin-right: ${SIZE.max40};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-right: 0;
  }
`;

export const MiddleContent = styled.div`
  width: 100%;
  padding-inline: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-left: solid 2px rgba(161, 161, 179, 0.2);
  border-right: solid 2px rgba(161, 161, 179, 0.2);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    border: none;
    padding-inline: ${SIZE.max10};
    -webkit-line-clamp: 2;
  }
`;

export const Antet = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column;
    gap: 0;
  }
`;

export const DownloadButtonWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  margin-left: ${SIZE.max40};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
`;
